export default __webpack_public_path__ + "static/media/stakingAction.3e7df417.webp";